import { apiRequest } from '../api/client';

/**
 * Member-facing HTTP calls (spec "Alumno"). `getOwnMember` always uses the id
 * `/auth/me` gave the session (`useAuth().user.id`), never a value the caller
 * could substitute for someone else's account — the server itself would
 * refuse a mismatched id with 403, but the client never even offers one.
 * `updateOwnProfile` hits the member-only whitelist (`PATCH /profile`:
 * username, fitnessGoal, targetDaysPerWeek), distinct from the admin-only
 * `PATCH /members/:id`.
 */
export const memberApi = {
  getOwnMember: userId => apiRequest(`/members/${encodeURIComponent(userId)}`),
  updateOwnProfile: input => apiRequest('/profile', { method: 'PATCH', body: input }),
};
